import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from "@vitality-ds/system";
import { BaseCheckboxRoot } from "./components/BaseCheckbox/styled";
import BaseCheckboxContainerStyles from "./styles/BaseCheckboxContainer.styles";
import BaseCheckboxTextStyles from "./styles/BaseCheckboxText.styles";
export var BaseCheckboxText = styled("label", BaseCheckboxTextStyles);
export var BaseCheckboxContainer = styled("div", BaseCheckboxContainerStyles, _defineProperty({}, "& ".concat(BaseCheckboxRoot), {
  marginTop: 1
}));